import { RootState } from '../store';

export const getAds = (state: RootState) => state.campaignAds.ads;
export const getCampaignAdsSessionKey = (state: RootState) => state.campaignAds.sessionKey;
